import { render } from "./EnvironmentReport.vue?vue&type=template&id=a89cb644&ts=true"
import script from "./EnvironmentReport.vue?vue&type=script&lang=ts"
export * from "./EnvironmentReport.vue?vue&type=script&lang=ts"

import "./EnvironmentReport.vue?vue&type=style&index=0&id=a89cb644&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__